import type { State } from "../store";
import type { Habit, UserHabit } from "./types";
import { getIsKnown } from "../user/selectors";
import { getBeginingOfDayInMs } from "../common/time";
import {
  getHabitComparator,
  getHabitLogComparator,
  getHasCompleteLogForDay,
} from "../log/util";
export function getIsHabitsLoaded(state: State): boolean {
  if (!getIsKnown(state)) {
    return false;
  }

  return state.habits.isLoaded === true;
}
export function getHabits(state: State): Array<Habit> | null {
  /** TODO, check if this works for new users... */
  if (state.log == null) {
    return null;
  }

  if (!getIsKnown(state) || state.log == null) {
    return [];
  }

  const beginingOfDayInMs = getBeginingOfDayInMs(state.time.time);
  return state.habits.habits
    .map((installedHabit) => {
      return {
        ...installedHabit.habit,
        isComplete: getHasCompleteLogForDay(
          beginingOfDayInMs,
          state.log,
          installedHabit.habit.habitId
        ),
      };
    })
    .sort(getHabitComparator(state.log, beginingOfDayInMs));
}
export function getHabit(
  state: State,
  userId: string,
  createdms: number
): Habit | null | undefined {
  for (var key in state.availableHabits.allHabits) {
    const habit = state.availableHabits.allHabits[key];

    if (habit.userId === userId && habit.createdms === createdms) {
      return habit;
    }
  }

  return null;
}
export function getHabitIsInstalled(
  state: State,
  habitId: string | null | undefined
) {
  if (habitId == null) {
    return false;
  }

  return getUserHabit(state, habitId) != null;
}
export function getUserHabit(
  state: State,
  habitId: string
): UserHabit | null | undefined {
  return state.habits.habits.find(
    (userHabit) => userHabit.habit.habitId === habitId
  );
}
export function getInstalledHabits(state: State): Array<UserHabit> {
  const installedHabits = state.availableHabits.installedHabits;
  const beginingOfDayInMs = getBeginingOfDayInMs(state.time.time);
  return installedHabits.sort(
    getHabitLogComparator(
      state.log,
      beginingOfDayInMs,
      (userHabit: UserHabit) => userHabit.habit.habitId
    )
  );
}
export function getAvailableHabits(state: State): Array<UserHabit> {
  const availableHabits = state.availableHabits.availableHabits;
  const habits = state.habits.habits;
  const beginingOfDayInMs = getBeginingOfDayInMs(state.time.time);
  return availableHabits
    .map((availableHabit) => {
      const installedHabit: UserHabit | null | undefined = habits.find(
        (installedHabit) =>
          installedHabit.habit.habitId === availableHabit.habit.habitId
      );
      return installedHabit || availableHabit;
    })
    .sort(
      getHabitLogComparator(
        state.log,
        beginingOfDayInMs,
        (userHabit: UserHabit) => userHabit.habit.habitId
      )
    );
}

export function getNextHabit(
  state: State,
  currentHabit: Habit | null
): Habit | null {
  const beginingOfDayInMs = getBeginingOfDayInMs(state.time.time);

  if (state.log == null) {
    return null;
  }

  // assume that the log is in chronological order
  const completedHabitIds = state.log
    .filter((entry) => beginingOfDayInMs <= entry.time)
    .map((entry) => entry.type);

  const incompleteHabits = state.habits.habits.filter(
    (userHabit) => !completedHabitIds.includes(userHabit.habit.habitId)
  );

  if (incompleteHabits == null || incompleteHabits.length === 0) {
    return null;
  }
  if (currentHabit == null) {
    return incompleteHabits[0].habit;
  } else {
    const index = incompleteHabits.findIndex(
      (userHabit) => userHabit.habit.habitId === currentHabit.habitId
    );
    if (index > -1 && index < incompleteHabits.length - 1) {
      return incompleteHabits[index + 1].habit;
    }
    return null;
  }
}
